var React = require('react');

function SelectArrows (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","opacity":".84981864"},[React.createElement("path",{"d":"M-7-3h23v23H-7z","key":0}),React.createElement("path",{"d":"M4.5 2.67277778l3.1078431 2.99388889L8.9901961 4.335 4.5 0 0 4.335l1.39215686 1.33166667L4.5 2.67277778zm0 11.65444442l-3.10784314-2.9938889L.00980392 12.665 4.5 17 9 12.665l-1.3921569-1.3316667L4.5 14.3272222z","fill":"#000","fillRule":"nonzero","key":1})]));
}

SelectArrows.defaultProps = {"viewBox":"0 0 20 20"};

module.exports = SelectArrows;

SelectArrows.default = SelectArrows;
